import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MStaticInter, MStaticClient } from '@argalis-apps/models';
import * as moment from 'moment';

@Component({
  selector: 'argalis-apps-static-inter-cards',
  templateUrl: './inter-cards.component.html',
  styleUrls: ['./inter-cards.component.scss']
})
export class InterCardsComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  public interStaticData: any;
  public indicator: boolean;
  public cardVisulisation: MStaticInter.IStatistiqueCardVisualisationInter;

  @Input('interStaticData')
  set _margeData(value: any) {
    this.interStaticData = value;
  }

  @Input('cardVisulisation')
  set _cardVisulisation(value: MStaticInter.IStatistiqueCardVisualisationInter) {
    this.cardVisulisation = value;
  }

  @Input('indicator')
  set _indicator(value: boolean) {
    this.indicator = value;
  }
  public headerBackground = 'uk-background-muted';
  public headerColor = 'no-style-applied';
  public bodyBackground = 'no-style-applied';
  public bodyColor = 'no-style-applied';

  constructor() {}

  ngOnInit() {}

  getDureeTotalIndispo(tab: MStaticInter.IIndispoInterv[]) {
    let diff = 0;
    for (const element of tab) {
      const momentDebut: any = moment(element.date_debut, 'DD/MM/YYYY HH:mm:ss');
      const momentFin = moment(element.date_fin, 'DD/MM/YYYY HH:mm:ss');
      diff += momentFin.diff(momentDebut);
    }
    const duration = moment.duration(diff);
    const hours = duration.asHours();
    const minutes = duration.asMinutes() % 60;
    if (minutes === 0) {
      return `${hours} heures`;
    } else {
      return `${hours} heures ${minutes} minutes`;
    }
  }

  getDureeIndispo(dateDebut, dateFin) {
    const momentDebut = moment(dateDebut, 'DD/MM/YYYY HH:mm:ss');
    const momentFin = moment(dateFin, 'DD/MM/YYYY HH:mm:ss');
    const duration = moment.duration(momentFin.diff(momentDebut));
    const hours = duration.asHours();
    const minutes = duration.asMinutes() % 60;
    if (minutes === 0) {
      return `${hours} heures`;
    } else {
      return `${hours} heures ${minutes} minutes`;
    }
  }
  getHeures(value) {
    let decimalTime = parseFloat(value);
    decimalTime = decimalTime * 60 * 60;
    const hours = Math.floor(decimalTime / (60 * 60));
    return hours;
  }

  getMinutes(value) {
    let decimalTime = parseFloat(value);
    decimalTime = decimalTime * 60 * 60;
    const hours = Math.floor(decimalTime / (60 * 60));
    decimalTime = decimalTime - hours * 60 * 60;
    const minutes = Math.floor(decimalTime / 60);
    return minutes;
  }
}
